import state from './module-send-to-developer-state';
import mutations from './module-send-to-developer-mutations';
import actions from './module-send-to-developer-actions';
import getters from './module-send-to-developer-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
